// extracted by mini-css-extract-plugin
export default {"section":"CoperateClients_section__xJHab","coperate":"CoperateClients_coperate__oMagk","imgs":"CoperateClients_imgs__kE8vI","clients":"CoperateClients_clients__RITlI"};